import { dummyAdvancePaymentBillData } from './dummyAdvancePaymentBillData';
import { getDiscoBillBranding } from './discoBillBranding';

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const hasValue = (value) =>
    value !== null && value !== undefined && String(value).trim() !== '';

const formatBillMonth = (dateString) => {
    if (!hasValue(dateString)) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    return `${MONTHS[date.getMonth()]} ${String(date.getFullYear()).slice(-2)}`;
};

const formatBillDate = (dateString) => {
    if (!hasValue(dateString)) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, '0');
    return `${day} ${MONTHS[date.getMonth()]} ${String(date.getFullYear()).slice(-2)}`;
};

const addDays = (dateString, days) => {
    if (!hasValue(dateString)) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;
    date.setDate(date.getDate() + days);
    return date;
};

const formatReferenceNo = (referenceNo) => {
    if (!hasValue(referenceNo)) return null;
    const clean = String(referenceNo).replace(/\s/g, '');
    if (clean.length >= 14) {
        return `${clean.slice(0, 2)} ${clean.slice(2, 7)} ${clean.slice(7)}`;
    }
    return clean;
};

const formatAmount = (amount) => {
    if (!hasValue(amount)) return null;
    const num = Number(amount);
    if (Number.isNaN(num)) return null;
    return Math.round(num).toLocaleString('en-US');
};

const getTariffCode = (row) => {
    const code = row.TARIFFCODE ?? row.tariffCode ?? row.tariffcode;
    return hasValue(code) ? String(code) : null;
};

export const mapApprovedAdvanceBillResponse = (apiResponse) => {
    const row = Array.isArray(apiResponse?.data) ? apiResponse.data[0] : apiResponse?.data;
    if (!row) return null;

    const approvedAmount = formatAmount(row.approvedAdvancePayment);
    const billDueDate = formatBillDate(row.currentBillDueDate);
    const dueDate = formatBillDate(addDays(row.currentBillDueDate, 30));
    const billMonth = formatBillMonth(row.currentBillMonth);
    const raastQr =
        apiResponse?.RAASTQR ||
        apiResponse?.['RAAST QR'] ||
        apiResponse?.raastQr ||
        null;
    const branding = getDiscoBillBranding(row.referenceNo);

    return {
        ...dummyAdvancePaymentBillData,
        ...branding,
        referenceNo: formatReferenceNo(row.referenceNo),
        consumerId: row.customerId ?? null,
        consumerName: row.applicantName ?? null,
        address: row.applicantAddress ?? null,
        billMonth,
        dueDate,
        readingDate: billDueDate,
        issueDate: billDueDate,
        applicationId: row.applicationId ?? null,
        applicantCNIC: row.applicantCNIC ?? null,
        applicantPhone: row.applicantPhone ?? null,
        tariffCode: getTariffCode(row),
        tariff: getTariffCode(row),
        category: row.consumerType ?? null,
        tariffCategory: row.tariffName ?? row.tariffDesc ?? null,
        subDivisionName: row.subDivisionName ?? null,
        subDivision: row.subDivisionName ?? null,
        payableWithinDueDate: approvedAmount,
        grandTotal: approvedAmount,
        payableAfterDueDateTill: approvedAmount,
        surchargeTillDate: dueDate,
        surchargeAfterDate: dueDate,
        fpaMessageUrdu: null,
        noticeUrdu: null,
        headerQrUrdu: null,
        sidebarQrUrdu: null,
        billMessagesLayoutOnly: true,
        // Keep the top/header QR, but remove the "below" QR/messages content.
        hideHeaderUrduText: false,
        hideQrContent: false,
        raastQr,
    };
};
